export const ADD_BOOKING_DETAILS_REQUEST = "ADD_BOOKING_DETAILS_REQUEST";
export const ADD_BOOKING_DETAILS_SUCCESS = "ADD_BOOKING_DETAILS_SUCCESS";
export const ADD_BOOKING_DETAILS_FAILURE = "ADD_BOOKING_DETAILS_FAILURE";

export const GET_BOOKING_DETAILS_REQUEST = "GET_BOOKING_DETAILS_REQUEST";
export const GET_BOOKING_DETAILS_SUCCESS = "GET_BOOKING_DETAILS_SUCCESS";
export const GET_BOOKING_DETAILS_FAILURE = "GET_BOOKING_DETAILS_FAILURE";